import { render, staticRenderFns } from "./CircleBubble.vue?vue&type=template&id=025b3d45&scoped=true&"
import script from "./CircleBubble.vue?vue&type=script&lang=js&"
export * from "./CircleBubble.vue?vue&type=script&lang=js&"
import style0 from "./CircleBubble.vue?vue&type=style&index=0&id=025b3d45&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025b3d45",
  null
  
)

export default component.exports